import { Status } from '@/models/CommonModels';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useCommonStore: any = defineStore('commonStore', () => {
  const status = ref<Status>(sessionStorage.getItem('status') != null ? JSON.parse(sessionStorage.status) : new Status());
  const serverContextMenu = ref<string | null>(null);

  function setStatus(newStatus: Status) {
    status.value = newStatus;
    sessionStorage.setItem('status', JSON.stringify(status.value));
  }

  function setServerContextMenu(activeMenu: string | null) {
    serverContextMenu.value = activeMenu;
  }

  return {
    status,
    serverContextMenu,
    setStatus,
    setServerContextMenu,
  };
});
